import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useState } from 'react';
import { getDeviceSource, ifElse } from 'services/helper-function.service';
import Text from './text/Text';
import * as lemnisk from '../services/lemnisk.service';
import Link from 'next/link';
import { configObj } from 'lib';

const Accordion = ({ listStyle='text-neutral-10 cursor-pointer mb-3', listMargin='ml-2 my-3', color='text-white', children, data, ...props }) => {
    const [active, setActive] = useState(false);
    return (
        <>
            
            <div className={`flex items-center justify-between cursor-pointer ${props.className}`} 
              onClick={
                ifElse(
                    data.subMenu,
                    () => setActive(!active),
                    ()=>{
                        lemnisk.trackEventRudderStack('Clicked', {
                            page_name: 'Services',
                            button_name: data.title?.toLowerCase(),
                            sub_section: 'bottom bar',
                            source: getDeviceSource()
                        });
                        if (data.a_tag) {
                            window.open(data.url, '_self');
                        } else {
                            window.open((configObj?.NEXT_PUBLIC_LIVSPACE_BASE_URL) + '/' + (props.countryCode || 'in') + '/' + data.url, '_self');
                        }
                    }
                )
              }
            >
                <div>{children}</div>
                {data.subMenu && <ExpandMoreIcon fontSize='small' className={`${color} transition-all transform ${active && 'rotate-180'} `} />}
            </div>
            {
                data.subMenu && active && 
                <div className={`${listMargin}`}>
                    {
                        data.subMenu.map((list) => {
                        return (
                                <Link 
                                    href={
                                        ifElse(
                                            list.a_tag,
                                            list.url,
                                            (configObj?.NEXT_PUBLIC_LIVSPACE_BASE_URL) + '/' + (props.countryCode || 'in') + '/' + list.url
                                        )
                                    }
                                    onClick={()=>{
                                        lemnisk.trackEventRudderStack('Clicked', {
                                            page_name: 'Services',
                                            button_name: list.title?.toLowerCase(),
                                            sub_section: 'bottom bar',
                                            source: getDeviceSource()
                                        });
                                    }} 
                                >
                                    <a>
                                        <Text type='bodyStyleSmall' className={`${listStyle}`}>{list.title}</Text>
                                    </a>
                                </Link>
                        );
                        })
                    }
                </div>
                
            }
            
        </>
    )
}

export default Accordion;